import { Component } from '@angular/core';

@Component({
  selector: 'services-carousel',
  templateUrl: './services-carousel.component.html',
  styleUrl: './services-carousel.component.scss',
  standalone: false
})
export class ServicesCarouselComponent {
  constructor() {}


  ngOnInit() {
    this.setServices();
    // this.getTempJobs();
  }


  async setServices() {

  }
}
